<template lang="">
  <div>
    <div class="aside-title mt-4">
      <i class="mr-4"></i>
      微信红包
    </div>
    <div class="aside-content px-4 mt-2">
      <div class="aside-item">
        通过短信向答题人推送答题链接,<el-button type="text" size="small" @click="goSmsLinks">操作说明</el-button>
      </div>
    </div>

    <div v-if="userEnum === userEnumMap.personal">
      <div class="aside-title mt-4">
        <i class="mr-4"></i>
        短信购买
      </div>
      <div class="aside-content px-4 mt-2">
        <div class="aside-item">
          如需购买短信，请<el-button type="text" size="small" @click="goSmsPay">前往购买</el-button>
        </div>
      </div>
    </div>

    <div  v-else-if="userEnum === userEnumMap.normal">
      <div class="aside-title mt-4">
        <i class="mr-4"></i>
        短信可用条数
      </div>
      <div class="aside-content px-4 mt-2">
        <div class="aside-item mb-2">
          问卷的短信可用条数由企业管理员分配，如需使用，请联系企业管理员。
        </div>
        <div class="aside-item mb-2" style="font-weight:600">
          企业管理员操作步骤:
        </div>
        <div class="aside-item mb-2">
          1. 点击企业 > 进入【管理企业钱包】
        </div>
        <el-image :src="asideImg01" fit="fill" :preview-src-list="[asideImg01]" :lazy="true"></el-image>
        <div class="aside-item mb-2">
          2. 进入【企业钱包】，选择【短信管理】找到【问卷红包】去设置
        </div>
        <el-image class="mb-2" :src="asideImg02" fit="fill" :preview-src-list="[asideImg02]" :lazy="true"></el-image>
        <div class="aside-item mb-2">
          3. 找到【问卷红包】去设置
        </div>
      </div>
    </div>

    <div  v-else-if="userEnum === userEnumMap.isAdmin">
      <div class="aside-title mt-4">
        <i class="mr-4"></i>
        短信可用条数
      </div>
      <div class="aside-content px-4 mt-2">
        <div class="aside-item mb-2">
          短信分配原则是专问卷专用，您可前往【<el-button type="text" size="small" @click="goSmsPay">企业钱包-短信管理</el-button>】为本问卷分配可用本次发送短信
        </div>
        <el-image :src="asideImg01" fit="fill" :preview-src-list="[asideImg01]" :lazy="true"></el-image>
        
      </div>
    </div>

  </div>
</template>
<script>
import asideImg01 from '@/assets/img/sms/aside-01.png'
import asideImg02 from '@/assets/img/sms/aside-02.png'
import GlobalConfig,{ AuthConfig } from '@/global/config'
import { toBasePlatform } from '@/assets/js/base-platform'
import { mapGetters } from 'vuex'

export default {
  data(){
    return{
      asideImg01,
      asideImg02,
      userEnumMap:{
        personal: 1, // 个人用户
        normal: 2,   // 普通员工
        isAdmin: 3   // 企业管理员
      }
    }
  },
  computed:{
    ...mapGetters(['userInfo']),
    userEnum:function(){
      console.log('GlobalConfig.getAuthCode()',GlobalConfig.getAuthCode())
      console.log('isAdmin',this.userInfo.isAdmin)
      if(this.userInfo.isAdmin){
        return 3
      }else{
        if([AuthConfig.Personal,AuthConfig.PersonalPlus].includes(GlobalConfig.getAuthCode())){
          return 1
        }else{
          return 2
        }
      }
    }
  },
  methods:{
    goSmsLinks(){
      window.open('https://www.yuque.com/surveywork/help/go8o8a')
    },
    // 去购买
    goSmsPay(){
      const {isQY,isAdmin} = this.userInfo
      // 清研企业并且为管理员进入新版短信管理 反之去老版
      if(isQY && isAdmin){
        const url = this.$router.resolve({path:'/company/funds/text-message'})
        window.open(url.href, '_blank')
      }else{
        const q = { token: GlobalConfig.getBaseToken(), companyid: GlobalConfig.getCompanyId() }
        toBasePlatform('/company/funds/textmessage', q)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .aside-title{
    display: flex;
    height: 22px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #000000d9;
    line-height: 22px;
    i{
      width: 4px; 
      height: 20px;
      background: var(--theme-color);
    }
  }
  .aside-item{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #000000d9;
    line-height: 24px;
  }
</style>